import React, { useEffect, useRef, useState } from "react";
import {
  Button,
  Col,
  Divider,
  Form,
  Input,
  message,
  Popconfirm,
  Row,
  Table,
} from "antd";
import { DeleteOutlined, EditOutlined } from "@ant-design/icons";
import { ExtractDate, ExtractTime } from "../../../../utils";
import {
  addPropertyType,
  deletePropertyType,
  getPropertyType,
  updatePropertyType,
} from "../PropertiesapiFunctions";
import ComponentTitle from "../../../../Common/ComponentTitle";

function AddPropertyType() {
  const [form] = Form.useForm();
  const [PropertyTypeData, setPropertyTypeData] = useState([]);
  const [from, setFrom] = useState("add");
  const [filldata, setFilldata] = useState({});
  const [isLoading, setIsLoading] = useState(false);

  const createPropertyType = (changedValues) => {
    if (from === "add") {
      const payload = {
        typeName: changedValues.typeName,
      };
      addPropertyType(payload)
        .then((response) => {
          if (response.data.status) {
            message.success({ content: response.data.message });
            form.resetFields();
            FetchPropertyTypeData();
          }
        })
        .catch((error) => console.error(error));
    } else {
      const payload = {
        typeId: filldata.id,
        newTypeName: changedValues.typeName,
      };

      updatePropertyType(payload)
        .then((response) => {
          if (response.data.status) {
            message.success({ content: response.data.message });
            form.resetFields();
            setFrom("add");
            FetchPropertyTypeData();
          }
        })
        .catch((error) => console.error(error));
    }
  };

  const FetchPropertyTypeData = () => {
    setIsLoading(true);
    getPropertyType()
      .then((response) => {
        if (response.data.status) {
          setIsLoading(false);
          setPropertyTypeData(response.data.data);
        }
      })
      .catch((err) => {
        console.error("Error fetching data", err);
        setIsLoading(false);
      });
  };

  useEffect(() => {
    FetchPropertyTypeData();
  }, []);

  useEffect(() => {
    if (from === "edit" && filldata) {
      form.setFieldsValue({
        typeName: filldata?.typeName,
      });
    } else {
      form.resetFields();
    }
  }, [from, filldata, form]);

  const DeleteAction = (record) => {
    let payload = {
      typeId: record.id,
    };
    deletePropertyType(payload)
      .then((response) => {
        if (response.data.status) {
          message.success(response.data.message);
          FetchPropertyTypeData();
        }
      })
      .catch((error) => console.error(error));
  };

  const columns = [
    {
      title: "Property Type Name",
      dataIndex: "typeName",
      key: "typeName",
      className: "custom-header font-poppins text-xs",

      render: (data) => <p>{data}</p>,
    },
    {
      title: "Created Date",
      dataIndex: "createdAt",
      key: "createdAt",
      className: "custom-header font-poppins text-xs",

      render: (data) => (
        <p>
          {ExtractDate(data)} • {ExtractTime(data)}
        </p>
      ),
    },
    {
      title: "Edit",
      dataIndex: "edit",
      key: "edit",
      className: "custom-header font-poppins text-xs",
      render: (data, record) => (
        <Button
          size="small"
          onClick={() => {
            setFrom("edit");
            setFilldata(record);
          }}
        >
          <EditOutlined />
        </Button>
      ),
    },
    {
      title: "Delete",
      dataIndex: "delete",
      key: "delete",
      className: "custom-header font-poppins text-xs",
      render: (data, record) => (
        <Popconfirm
          title="Are you sure you want to delete this Property Type?"
          onConfirm={() => DeleteAction(record)}
          okText="Yes"
          cancelText="No"
        >
          <DeleteOutlined />
        </Popconfirm>
      ),
    },
  ];

  return (
    <div>
      <div>
        <ComponentTitle title={"Add Property Type "} />

        <Form
          layout="vertical"
          form={form}
          onFinish={createPropertyType}
          initialValues={{ typeName: "" }}
        >
          <Row gutter={[16, 16]} align="middle">
            <Col xs={24} sm={12}>
              <Form.Item
                label=" Type Name"
                name="typeName"
                rules={[
                  { required: true, message: "Please enter a Name" },
                  {
                    type: "string",
                    message: "Please enter a valid Property Type",
                  },
                ]}
              >
                <Input
                  placeholder="Enter  Type name"
                  className="rounded-md p-2 border-gray-300"
                />
              </Form.Item>
            </Col>

            <Col xs={24} sm={12} className="flex items-end">
              <Button
                className="bg-rgbaprimary9 text-white text-sm px-4 py-2 rounded-md transition-all hover:bg-rgbaprimary8 w-full sm:w-auto"
                size="middle"
                htmlType="submit"
              >
                {from === "add"
                  ? "Create Property Type"
                  : "Update Property Type"}
              </Button>
            </Col>
          </Row>
        </Form>

        <ComponentTitle title={"Property Type List "} />

        <div
          style={{ maxHeight: "540px", overflow: "auto" }}
          className="bg-white shadow-md  shadow-[rgba(149, 157, 165, 0.2) 0px 8px 24px]"
        >
          <Table
            columns={columns}
            className="w-screen sm:w-screen custom-table-header"
            dataSource={PropertyTypeData}
            pagination={false}
            loading={isLoading}
          />
        </div>
      </div>
    </div>
  );
}

export default AddPropertyType;
